export default "__VITE_ASSET__DBXC$PNT__"